<template>
  <footer class="relative bg-gray-300 pt-8 pb-6">
    <div
      class="bottom-auto top-0 left-0 right-0 w-full absolute pointer-events-none overflow-hidden -mt-20 h-20"
      style="transform: translateZ(0);"
    >
      <svg
        class="absolute bottom-0 overflow-hidden"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
        version="1.1"
        viewBox="0 0 2560 100"
        x="0"
        y="0"
      >
        <polygon
          class="text-gray-300 fill-current"
          points="2560 0 2560 100 0 100"
        ></polygon>
      </svg>
    </div>
    <div class="container mx-auto px-4">
      <div
        class="flex flex-wrap items-center md:justify-between justify-center"
      >
        <div class="w-full md:w-10/12 px-4 mx-auto text-center">
          <div class="text-sm text-gray-600 font-semibold py-1">
            NOIT {{ date }} -  Category "Distributed Web Applications" | Aleks Milchov and David Ivanov | 
            <a
              href="https://pgi-pernik.bg-schools.com/"
              target="_blank"
              class="text-gray-600 hover:text-gray-900"
            >
              PGI Pernik
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
/* 
  Class: Footer
  Description: This class representing a footer of the application.
*/

export default {
  /* 
    Define data with custom date state values. 
  */
  data() {
    return {
      date: new Date().getFullYear(),
    };
  },

  /* 
    Define props from which we got chart data.
  */
  props: {
   absolute: {
      type: Boolean,
      default: false,
    },
  }
};
</script>
